const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ commons
import OKLayout from 'components/commons/OKLayout/OKLayout';
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { getLastNChars } = require('utilities/stringHelper');
// @ actions
const accountChequebookActions = require('actions/accountChequebook');
// @ components
const AccountMoreOptionsButton = require('components/accounts/accountMoreOptionsButton/accountMoreOptionsButton');
const AccountChequebookMovements = require('components/accounts/accountChequebookMovements/accountChequebookMovements');
// @ constants
const { HYPHEN } = require('constants/index');
const { accountConstants } = require('utilities/accessHelperConditions/accounts');
import { NEGATIVE } from 'constants/layout';
//@utilities
const AccessHelper = require('utilities/accessHelper');

class AccountChequebookView extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        const { history, match: { params: { accountId, chequebookIndex } }, requestChequebook, immAccounts, immAccountsCheques } = this.props;

        AccessHelper.allowAccess(accountConstants.ACCOUNTS_CHEQUEBOOK, { immAccounts, accountId, chequebookIndex, immAccountsCheques }, history);
        requestChequebook(accountId, chequebookIndex);
    }

    render() {

        const { match: { params: { accountId, chequebookIndex } }, requestChequebook, setAccountChequebookFilter, immAccountsCheques, immAccounts } = this.props;
        const immAccount = immAccounts.get('byId').get(accountId);
        const subtitleLeft = immAccount.get('catalogData').get('subtype');
        const subtitleRight = getLastNChars(immAccount.get('iban'));

        const immCheques = immAccountsCheques.get(accountId);
        const chequebookId = immCheques.get('byOrder').get(chequebookIndex);
        const immCheque = immCheques.get('byId').get(chequebookId);

        const initialNum = immCheque.get('initialNum');
        const finalNum = immCheque.get('finalNum');

        const injectedStrings = `(N° ${initialNum} ${HYPHEN} ${finalNum})`;

        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-accounts'),
                url: '/myprofile/accounts'
            },
            {
                text: immAccount.get('alias'),
                url: `/myprofile/accounts/${accountId}/movements`
            },
            {
                text: formatText('accountCheques-chequebooks'),
                url: `/myprofile/accounts/${accountId}/cheques`
            },
            {
                text: formatText('accountCheques-cheques')
            }
        ];

        return (
            <OKLayout
                breadcrumb={mappingBreadcrumb}
                buttons={<AccountMoreOptionsButton accountId={accountId} />}
                className="account-chequebook-view"
                contentPosition={NEGATIVE}
                loading={!immAccount || !immAccountsCheques.get(accountId) || immAccountsCheques.get(accountId).get('byOrder').size == 0}
                title={getFinalTitle('accountCheques-usedChequesRange', [injectedStrings])}
                section="accounts"
                subtitleLeft={subtitleLeft}
                subtitleRight={subtitleRight}
            >
                <OKSectionBox>
                    <div className="row">
                        <div className="col-xs-12">
                            <AccountChequebookMovements
                                chequebookIndex={chequebookIndex}
                                accountId={accountId}
                                requestChequebook={requestChequebook}
                                setAccountChequebookFilter={setAccountChequebookFilter}
                                immCheques={immCheques}
                            />
                        </div>
                    </div>
                </OKSectionBox>
            </OKLayout>
        );
    }
}

AccountChequebookView.propTypes = {
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immAccountsCheques: PropTypes.object.isRequired,
    requestChequebook: PropTypes.func.isRequired,
    setAccountChequebookFilter: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired
};

module.exports.constructor = AccountChequebookView;
module.exports.AccountChequebookView = connect(
    state => ({
        immAccounts: state.accounts,
        immAccountsCheques: state.accountsCheques
    }), {
    requestChequebook: accountChequebookActions.requestChequebook,
    setAccountChequebookFilter: accountChequebookActions.setAccountChequebookFilter
})(withRouter(AccountChequebookView));
